import React from 'react';
import { Input, Select, Button } from './FormControls';
import { StepProps } from './types';

interface StepCommitmentProps extends StepProps {
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

const StepCommitment: React.FC<StepCommitmentProps> = ({ formData, onChange, onBack, onSubmit, isSubmitting }) => (
  <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
    <h3 className="text-2xl font-black text-gray-900">Commitment & Availability</h3>

    <div className="space-y-6">
      <Select
        label="How many videos per week can you realistically commit to?"
        value={formData.videosPerWeek}
        onChange={v => onChange({ videosPerWeek: v })}
        options={[
          "3-4 videos per week",
          "5-6 videos per week (recommended)",
          "7+ videos per week (daily)"
        ]}
        required
      />

      <div className="space-y-3">
        <label className="block text-sm font-bold text-gray-700">Are you available for a weekly 30-minute team call?</label>
        <div className="flex gap-4">
          {['Yes', 'No'].map(opt => (
            <label key={opt} className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="weeklyCall"
                checked={formData.weeklyCall === opt}
                onChange={() => onChange({ weeklyCall: opt as 'Yes' | 'No' })}
                className="w-4 h-4 text-purple-600 focus:ring-violet-400"
              />
              <span className="text-sm font-medium text-gray-700">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <Input
        label="What days/times work best for calls? (in your timezone)"
        value={formData.bestCallTimes}
        onChange={v => onChange({ bestCallTimes: v })}
        placeholder="e.g. Mon/Wed after 5pm EST"
        required
      />

      <div className="space-y-2">
        <label className="block text-sm font-bold text-gray-700">Do you have any other content commitments or jobs we should know about?</label>
        <textarea
          rows={3}
          className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-violet-400 outline-none transition-all font-medium resize-none"
          value={formData.otherCommitments || ''}
          onChange={e => onChange({ otherCommitments: e.target.value })}
        />
      </div>
    </div>

    <div className="flex justify-between pt-6">
      <Button variant="secondary" onClick={onBack}>← Back</Button>
      <button
        onClick={onSubmit}
        disabled={isSubmitting}
        className="px-8 py-3 bg-[#341368] text-white rounded-xl font-bold hover:bg-purple-800 transition-all shadow-lg shadow-purple-500/20 disabled:opacity-50 flex items-center gap-2"
      >
        {isSubmitting ? 'Submitting...' : 'Submit Application'}
      </button>
    </div>
  </div>
);

export default StepCommitment;
